<template>
  <div class="uni-course-subject">
    <!-- top -->
    <el-row :gutter="10">
      <el-col :span="18">
        <div class="top-box subject-study" style="height: 240px">
          <div class="img-box">
            <el-image
              :src="datas.thumb"
              fit="contain"
              class="img"
              v-if="datas.thumb"
            />
            <el-image
              :src="require('@/views/business/course/image/mycourse.jpg')"
              fit="contain"
              class="img"
              v-else
            />
          </div>
          <div class="info-box">
            <h1 class="title">
              <span class="span1">当前课程：</span>
              {{ datas.title }}
              <span class="span2">({{ datas.credit }}学分)</span>
            </h1>
            <el-row :gutter="20">
              <el-col
                :span="item.title === '学习总时长' ? 10 : 7"
                v-for="(item, key) in subData"
                :key="key"
              >
                <ComponentCircleProgress
                  v-if="courseType == 2 || (courseType != 2 && key != 'work')"
                  :color="subDataColor[key]"
                  :datas="item"
                  :progressWidth="100"
                ></ComponentCircleProgress>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>

      <el-col :span="6">
        <div class="top-box subject-note" style="height: 240px">
          <div class="uni-link-title">
            <h3>
              <span class="bold">课程说明</span>
              <i class="iconfont iconicon-test"></i>
            </h3>
          </div>

          <div class="note-list">
            <div
              v-if="datas.explain"
              class="note-desc"
              v-html="datas.explain"
            ></div>
            <ComponentEmpty
              v-else
              style="padding: 0"
              imgClass="img-size"
              title="暂无课程说明"
              tips=""
            />
            <div style="text-align: right">
              <span
                class="gray-link mat10"
                @click="noteMore"
                v-if="datas.explain"
                >查看更多</span
              >
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 课件下载 -->
    <div class="online" v-if="datas.courseware">
      <div class="onlineName">
        <img
          v-if="fileName === 'pdf'"
          class="onlineNameImg"
          src="../../../assets/images/PDF.svg"
          alt=""
        />
        <img
          v-else-if="fileName === 'docx'"
          class="onlineNameImg"
          src="../../../assets/images/word.svg"
          alt=""
        />
        <img
          v-else
          class="onlineNameImg"
          src="../../../assets/images/courseware.svg"
          alt=""
        />
        <p>
          课程名称：<span>{{ datas.title }}</span>
        </p>
      </div>
      <a :href="datas.courseware" target="_blank">
        <div class="onlineButton"><em></em><span>课件下载</span></div>
      </a>
    </div>
    <!-- bottom -->
    <div class="bottom-box mat20">
      <ComponentCollapse
        ref="componentCollapse"
        :dataObj="datas"
        :activeNamesList="collapseData"
        :activeNames="activeNames"
        :isAllowed="isAllowed"
      />
      <ComponentEmpty
        tips
        title="暂无课程列表"
        v-if="collapseData.length == 0"
      />
    </div>
    <!-- 注意事项弹窗 -->
    <el-dialog title="课程说明" :visible.sync="noteMoreVisible" top="30vh">
      <div class="note-modal" v-html="datas.explain"></div>
    </el-dialog>
  </div>
</template>

<script>
import { getCourseDetails, getWorkPercent, getSections } from "@/api/basic";
import ComponentCollapse from "@/components/componentCollapseToAdult";
import ComponentCircleProgress from "@/components/componentCircleProgress";
export default {
  name: "subjectAdult",
  components: {
    ComponentCollapse,
    ComponentCircleProgress,
  },
  data() {
    return {
      courseId: this.$route.query.id,
      courseType: this.$route.query.type,
      datas: {},
      course_rate: {},
      noteMoreVisible: false,
      subData: {
        course: {
          title: "当前章节",
          total: 0,
          current: 0,
          percent: 0,
        },
        time: {
          title: "学习总时长",
          total: 0,
          current: 0,
          percent: 0,
        },
        work: {
          title: "学习总时长",
          total: 0,
          current: 0,
          percent: 0,
        },
      },
      subDataColor: {
        course: "",
        work: "#CD2E03",
        time: "#2AB247",
      },
      collapseData: [], // 章节列表
      activeNames: 0,
      fileName: "",
      isAllowed: 0,  //是否允许开始学习 0否 1是
    };
  },
  mounted() {
    this.getDatas().then(() => {
      this.getSections();
    });
    if (this.courseType == 2) {
      this.getWork();
    }
  },
  methods: {
    // 课程详情
    async getDatas() {
      const params = {
        course_id: this.courseId,
      };
      const { result } = await getCourseDetails(params);
      if (result) {
        const { course, course_rate } = result;
        const {
          sum_chapters,
          learn_chapters,
          sum_duration,
          sum_learn_duration,
          sum_duration_format,
          sum_learn_duration_format,
        } = course_rate;

        this.datas = course;
        // console.log(this.datas);
        this.course_rate = course_rate; //正在学习的章节id
        this.subData.course = {
          title: "当前章节",
          total: sum_chapters,
          current: learn_chapters,
          percent: this.percent(learn_chapters, sum_chapters),
        };
        this.subData.time = {
          title: "学习总时长",
          total: sum_duration_format,
          current: sum_learn_duration_format,
          percent: this.percent(sum_learn_duration, sum_duration),
        };
        this.isAllowed = course.is_allowed;
      }
    },
    // 认定课程=》练习作业进度
    async getWork() {
      const params = {
        course_id: this.courseId,
      };
      const { result } = await getWorkPercent(params);
      if (result) {
        const { task_done_num, task_num } = result;
        this.subData.work = {
          title: "练习作业",
          total: task_num,
          current: task_done_num,
          percent: this.percent(task_done_num, task_num),
        };
      }
    },
    percent(cur, total) {
      let percent = 0;
      if (total != 0) {
        percent = parseInt((cur / total) * 100);
      }
      return percent;
    },
    // 章节列表
    async getSections() {
      const params = {
        course_id: this.courseId,
      };
      const { result } = await getSections(params);
      if (result) {
        this.collapseData = result;

        if(result.length > 0){
          // 展开当前正在学习的章节
          let last_section_id = this.course_rate.last_section_id;
          if (last_section_id) {
            result.forEach((item) => {
              let hasNode = item.node.some((val) => last_section_id == val.id);
              if (hasNode) {
                this.activeNames = item.id;
              }
            });
          } else {
            this.activeNames = result[0].id;
          }
        }
      }
    },
    // 注意事项查看更多
    noteMore() {
      this.noteMoreVisible = !this.noteMoreVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
.uni-course-subject {
  padding: 0 20px;
  min-height: $menuH;

  /deep/ .img-size {
    width: 100px !important;
  }
  .online {
    width: 100%;
    height: 100px;
    background-color: #fff;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .onlineName {
      display: flex;
      align-items: center;
      .onlineNameImg {
        width: 56px;
        height: 66px;
        margin: 0 27px 0 33px;
      }
      p {
        font-size: 16px;
        color: #333;
        font-weight: bold;
        span {
          color: #666;
          font-weight: 500;
        }
      }
    }
    .onlineButton {
      width: 120px;
      height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-right: 30px;
      cursor: pointer;
      span {
        font-size: 15px;
        color: #ff6800;
        margin-left: 5px;
      }
      em {
        width: 23px;
        height: 22px;
        background: url("~@/assets/images/downloadIcon.png") no-repeat;
        background-size: 100% 100%;
      }
      &:hover {
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
      }
    }
  }
  .uni-link-title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .iconfont {
      font-size: 20px;
      vertical-align: middle;
      margin-left: 4px;
    }
  }

  .top-box {
    background: #fff;
    margin-top: 20px;
    padding: 20px;

    &.subject-study {
      display: flex;

      .img-box {
        width: 340px;
        // height: 100%;
        background: $grayBgLight;
        overflow: hidden;
        border: 1px solid $grayBorder;

        .img {
          border-radius: 8px;
          width: 100%;
          height: 100%;
        }
      }

      .info-box {
        flex: 1;
        margin-left: 20px;

        .title {
          font-size: 18px;
          color: $grayColor;
          display: flex;
          align-items: center;

          .span1 {
            font-size: 20px;
            font-weight: bold;
            color: $textColor;
          }

          .span2 {
            @include fontColor("primary");
            font-weight: bold;
            margin-left: 5px;
          }
        }
      }

      &.subject-note {
      }
    }

    .note-desc {
      height: 130px;
      overflow: hidden;
    }

    .bottom-box {
      margin-top: 10px;
    }

    .note-modal {
      line-height: 30px;
    }
  }
}
</style>
